var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFactoryIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 447.3 849.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#344d5f;stroke-linecap:round;stroke-linejoin:round;stroke-width:34px;}.cls-3{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -12.32)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.2,
    width: 364.56,
    height: 656.82
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,662.37l411.49-1.76q.9,91.78,1.81,183.56l-412.79.46Z",
    transform: "translate(0 -12.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.32,179.14l54.91-54.92c23.09-23.09,24.68-58.92,3.56-80s-57-19.53-80,3.55A64.65,64.65,0,0,0,229.07,57c-26-10.45-58.26-4-80.92,18.67C118.64,105.15,116.61,151,143.6,178l.71.7c-.72.64-1.43,1.31-2.13,2-17.3,17.3-18.49,44.15-2.66,60s42.67,14.63,60-2.67",
    transform: "translate(0 -12.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350,260.21l37.72-50.74c15.86-21.34,12.9-50.39-6.62-64.9s-48.19-9-64.05,12.35a52.63,52.63,0,0,0-5.09,8.36c-22.17-5.34-47.4,3.69-63,24.63-20.27,27.26-16.48,64.4,8.46,82.94l.66.48c-.5.6-1,1.22-1.48,1.87-11.88,16-9.66,37.75,5,48.62s36.11,6.73,48-9.25",
    transform: "translate(0 -12.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.9,
    y: 653.77,
    width: 299.39,
    height: 42.62
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.28,285c0,16.19-21.55,378.43-21.55,378.43l116.11-1.21L178.69,283.71Z",
    transform: "translate(0 -12.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M257.38,367.77,241.7,672.51l102.07-2.82L321.91,371.22Z",
    transform: "translate(0 -12.32)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryIco);
export default __webpack_public_path__ + "static/media/factory-ico.327ac5f2.svg";
export { ForwardRef as ReactComponent };